import { gql } from "@apollo/client";
import { ContaminationDeclarationFields } from "../fragments/contaminationDeclaration";

// Takes the ASSET_REMOVE event id; everything afterwards addresses the
// declaration by its own id. `input` is optional — an empty declaration is a
// legitimate start and the backend fills the snapshot + prefill itself.
export const CreateContaminationDeclaration = gql`
    mutation CreateContaminationDeclaration (
        $installedBaseEventId: ID!,
        $input: ContaminationDeclarationCreateAttributesInput
    ) {
        createContaminationDeclaration (installedBaseEventId: $installedBaseEventId, input: $input) {
            ...ContaminationDeclarationFields
        }
    }
    ${ContaminationDeclarationFields}
`;
